import React, { createContext, useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import './DashboardLayout.css';
import { useAuth } from '../../../context/AuthContext';
import DashboardNavbar from '../DashboardNavbar/DashboardNavbar';
import DashboardSidebar from '../DashboardSidebar/DashboardSidebar';
import facilities from '../../../config/facilities';

const LayoutContext = createContext({
  isCollapsed: false,
  setIsCollapsed: () => {},
});

export const useLayout = () => useContext(LayoutContext);

const DashboardLayout = ({
  children,
  isLoading = false,
  setIsLoading,
  facilityId,
}) => {
  const { userLoading } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 768); // Collapsed by default on phone

  useEffect(() => {
    const originalBodyOverflow = document.body.style.overflow;
    const footer = document.querySelector('footer');
    const originalFooterDisplay = footer ? footer.style.display : '';
    document.body.style.overflow = 'hidden';
    if (footer) footer.style.display = 'none';
    return () => {
      document.body.style.overflow = originalBodyOverflow;
      if (footer) footer.style.display = originalFooterDisplay;
    };
  }, []);

  const facility = facilities.find((f) => f.id === facilityId) ?? facilities[0];

  return (
    <LayoutContext.Provider value={{ isCollapsed, setIsCollapsed }}>
      <DashboardNavbar />
      <div
        style={{
          '--facilityDarkColor': facility.darkColor,
          '--facilityLightColor': facility.lightColor,
          '--facilitytextColor': facility.textColor,
        }}
        className={`dashboardContainer ${isCollapsed ? 'collapsed' : ''}`}
      >
        <DashboardSidebar />
        <div className="dashboardWrapper">
          <div className="dashboardContent">{children}</div>
        </div>
      </div>
      {(isLoading || userLoading) && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(200, 200, 200, 0.5)',
            zIndex: 10000,
          }}
        >
          <CircularProgress />
        </div>
      )}
    </LayoutContext.Provider>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  setIsLoading: PropTypes.func,
  facilityId: PropTypes.string.isRequired,
};

export default DashboardLayout;
